import '../../styles/sections/image-banner.scss';


const HIDDEN_CLASS = 'image-banner__video--hidden';
const VIDEO_CLASS = 'image-banner__video';

class ImageBannerMedia extends HTMLElement {
  constructor() {
    super();
    this._onPlaying = this._onPlaying.bind(this);
  }

  connectedCallback() {
    const videos = this.querySelectorAll('.image-banner__video-wrapper video');
    videos.forEach((video) => {
      video.classList.add(VIDEO_CLASS, HIDDEN_CLASS);
      video.addEventListener('playing', this._onPlaying, { once: true });
    });
  }

  disconnectedCallback() {
    const videos = this.querySelectorAll('.image-banner__video-wrapper video');
    videos.forEach((video) => video.removeEventListener('playing', this._onPlaying));
  }

  _onPlaying(e) {
    const video = e?.target;
    if (video) video.classList.remove(HIDDEN_CLASS);
  }
}

if (!customElements.get('image-banner-media')) {
  customElements.define('image-banner-media', ImageBannerMedia);
}
